
        var result = require("!!../../../../node_modules/css-loader/index.js!./groups-list.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./app/components/groups-list/groups-list.component.css
// module id = 1420
// module chunks = 0